module.exports = __webpack_public_path__ + "img/23.7fe2666.jpg";